import { Stack, StackProps } from '@mui/material';
const Section = ({
  children,
  sx,
  ...rest
}: StackProps) => {
  return <Stack gap={{
    xs: 'var(--spacing_l)',
    md: 'var(--spacing_xxxl)'
  }} component='section' sx={{
    py: 'var(--spacing_xxxl)',
    ...sx
  }} {...rest} data-sentry-element="Stack" data-sentry-component="Section" data-sentry-source-file="Section.tsx">
      {children}
    </Stack>;
};
export default Section;